import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=471cc7e9&scoped=true"
import script from "./Files.vue?vue&type=script&lang=js"
export * from "./Files.vue?vue&type=script&lang=js"
import style0 from "./Files.vue?vue&type=style&index=0&id=471cc7e9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471cc7e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('471cc7e9')) {
      api.createRecord('471cc7e9', component.options)
    } else {
      api.reload('471cc7e9', component.options)
    }
    module.hot.accept("./Files.vue?vue&type=template&id=471cc7e9&scoped=true", function () {
      api.rerender('471cc7e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/Post/Card/Files.vue"
export default component.exports